module.exports = __webpack_public_path__ + "img/weiwendi-500x500.09ac08ea.jpg";